import React from "react";
import Table from "@material-ui/core/Table";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { useTablesStyle } from "../../../styles/tableStyle";
import { IconButton, Avatar, Tooltip, Collapse } from "@material-ui/core";
import { GetAppOutlined } from "@material-ui/icons";
import {
  downloadSingleOrderFile,
  getSubOrder,
} from "../../../redux/Orders/ordersActions";
// import Store from "../../../redux/Store";
// import { getSubOrders } from "../../../redux/Orders/OrderActionCreators";

function OrderDetailTable({
  subOrders,
  rowValue,
  orderId,
  Load_Downoad,
  modal_loading,
}) {
  const classes = useTablesStyle();

  React.useEffect(() => {
    getSubOrder(orderId);
    return () => {
      // Store.dispatch(getSubOrders([]));
    };
  }, [rowValue, orderId]);

  return (
    <>
      <Collapse in={subOrders.length !== 0} unmountOnExit mountOnEnter>
        <TableContainer elevation={0} component={Paper} style={{}}>
          <Table size="small" style={{ width: "100%" }}>
            <TableHead>
              <TableRow className={classes.TableRow} style={{ height: 53 }}>
                {tableHead.map((item, index) => {
                  return (
                    <TableCell
                      key={index}
                      className={classes.TableCell}
                      width={item.width}
                      style={{}}
                    >
                      <Typography variant="subtitle1">{item.title}</Typography>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {subOrders.map((row, index) => {
                return (
                  <TableRow key={index} className={classes.TableRow}>
                    <TableCell className={classes.TableCell} width="5%">
                      <Typography color="textSecondary" variant="subtitle2">
                        {index + 1}
                      </Typography>
                    </TableCell>
                    <TableCell
                      className={classes.TableCell}
                      width="150px"
                      style={{
                        justifyContent: "right",
                      }}
                    >
                      <Tooltip
                        title={row.file_name}
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Typography
                          color="textSecondary"
                          variant="body2"
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {row.file_name}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell width="10%" className={classes.TableCell}>
                      <IconButton
                        size="small"
                        disabled={Load_Downoad.single ? true : false}
                        onClick={() => {
                          downloadSingleOrderFile(
                            row.id,
                            row.file_id,
                            row.download_file_name,
                            rowValue
                          );
                        }}
                      >
                        <Typography
                          color={Load_Downoad.single ? "initial" : "primary"}
                          variant="subtitle2"
                        >
                          {row.service}
                        </Typography>
                      </IconButton>
                    </TableCell>
                    <TableCell
                      width="250px"
                      className={classes.TableCell}
                      style={{ justifyContent: "right" }}
                    >
                      <Tooltip
                        title={row.descr}
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Typography
                          color="textSecondary"
                          variant="subtitle2"
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {row.descr}
                        </Typography>
                      </Tooltip>
                    </TableCell>

                    <TableCell width="10%" className={classes.TableCell}>
                      <Avatar className={classes.Avatar}>
                        {row.descr2.qtty}
                      </Avatar>
                    </TableCell>
                    <TableCell width="10%" className={classes.TableCell}>
                      <Typography color="textSecondary" variant="subtitle2">
                        {Number(row.unit_price).toLocaleString()}
                      </Typography>
                    </TableCell>
                    <TableCell width="10%" className={classes.TableCell}>
                      <Avatar className={classes.Avatar}>
                        {row.descr2.manipulate}
                      </Avatar>
                    </TableCell>
                    <TableCell width="10%" className={classes.TableCell}>
                      <Typography color="textSecondary" variant="subtitle2">
                        {Number(
                          row.unit_price * row.manipulate
                        ).toLocaleString()}
                      </Typography>
                    </TableCell>
                    <TableCell width="10%" className={classes.TableCell}>
                      <IconButton
                        disabled={Load_Downoad.single ? true : false}
                        onClick={() => {
                          downloadSingleOrderFile(
                            row.id,
                            row.file_id,
                            row.download_file_name,
                            rowValue
                          );
                        }}
                      >
                        <GetAppOutlined
                          color={Load_Downoad.single ? "disabled" : "primary"}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Collapse>
    </>
  );
}
const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { subOrders, refresh, Load_Downoad, loading, modal_loading } =
    OrderReducer;
  return { subOrders, refresh, Load_Downoad, loading, modal_loading };
};

export default connect(mapStateToProps)(OrderDetailTable);

const tableHead = [
  { title: "ردیف", width: "5%", field: "id" },
  { title: "نام فایل", width: "150px", field: "name" },
  { title: "نوع سفارش", width: "10%", field: "type" },
  { title: "تنظیمات فایل", width: "250px", field: "descr" },
  { title: "تعداد برگ", width: "10%", field: "qtty" },
  { title: "قیمت واحد", width: "10%", field: "price" },
  { title: "تعداد چاپ", width: "10%", field: "manipulate" },
  { title: "قیمت کل", width: "10%", field: "total" },
  { title: "دانلود", width: "10%", field: "id" },
];
